<!-- 增项提成 -->
<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar title="增项提成详情" left-text="返回" left-arrow @click-left="goback" />
      <van-grid :column-num="1" v-if="recordList.length > 0">
        <van-grid-item>
          <span>{{ `记录数量: ${recordList.length} | 总提成金额：${totalCommissionAmount}` }}</span>
        </van-grid-item>
        <van-grid-item class="vant-grid-item_content">
          <van-search v-model.trim="params.content" style=" width: 100%; padding-block: 2px; padding-top: 10px;"
            placeholder="品牌/车型/客户名/客户电话/主机厂/上游/车架">
          </van-search>
          <van-search v-model.trim="params.installerName" style=" width: 100%;padding-block: 2px ;" placeholder="被提成师傅">
          </van-search>
          <van-row type="flex" justify="end" style="width: 100%; margin-right: 20px;">
            <van-col>
              <van-button type="default" style="color: red; border: 0px; padding-right: 0px;height: 34px;"
                @click="search()">查询</van-button>
              <van-button type="default" style="color: red; border: 0px; padding-right: 0px;height: 34px;"
                @click="onClear()">清空</van-button>
            </van-col>
          </van-row>
        </van-grid-item>
      </van-grid>
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell-group v-for="(item, index) in recordListFiltered" :key="index" style="margin: 1.2rem; text-align: left"
        inset>
        <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
          {{ item.settlementBatchName }}
        </div>
        <van-field label="增项金额" :value="item.addOutlay" input-align="right" readonly label-width="5rem" />
        <van-field label="提成金额" :value="item.commissionAmount" input-align="right" readonly label-width="5rem" />
        <van-field label="提成比例" :value="item.commissionRate + '%'" input-align="right" readonly label-width="5rem" />
        <van-field label="提成师傅" :value="item.commissionUserName" input-align="right" readonly label-width="5rem" />
        <van-field label="被提成师傅" :value="item.installerName" input-align="right" readonly label-width="5rem" />
        <van-field label="提成备注" :value="item.commissionRemarks" type="textarea" autosize input-align="right" rows="1" readonly
          label-width="5rem" />
        <van-field label="所属公司" :value="item.companyName" input-align="right" readonly label-width="5rem" />
        <van-field label="品牌" :value="item.brandName" input-align="right" readonly label-width="5rem" />
        <van-field label="车型" :value="item.modelName" input-align="right" readonly label-width="6rem" />
        <van-field label="主机订单号" :value="item.mainOrderNo" input-align="right" readonly label-width="5rem" />
        <van-field label="上游订单号" :value="item.upstreamOrderNo" input-align="right" readonly label-width="5rem" />
        <van-field label="客户名称" :value="item.customerName" input-align="right" readonly label-width="5rem" />
        <van-field label="联系方式" :value="item.contactInfo" input-align="right" readonly label-width="5rem" />
        <van-field label="车架号" :value="item.vin" input-align="right" readonly label-width="5rem" />
      </van-cell-group>
    </van-list>
  </div>
</template>
<script>
import Big from "big.js";
import { multipleFuzzyQueries } from "@/views/settlement/columns.js";
const FUZZY_KEYS = ["customerName", "contactInfo", "vin", "brandName", "modelName", "mainOrderNo", "upstreamOrderNo"]
export default {
  name: "CommissionPage",
  data() {
    return {
      loading: false,
      finished: false,
      recordList: [],
      recordListFiltered: [],
      totalCommissionAmount: 0,
      params: {
        installerName: "",
        content: ""
      }
    };
  },
  methods: {
    search() {
      if (this.params.installerName || this.params.content) {
        let filtered = this.recordList;
        if (this.params.installerName) {
          filtered = filtered.filter(item => 
            item.installerName && item.installerName.includes(this.params.installerName)
          );
        }
        if (this.params.content) {
          filtered = multipleFuzzyQueries(filtered, this.params.content, FUZZY_KEYS);
        }
        this.recordListFiltered = filtered;
      } else {
        this.recordListFiltered = this.recordList;
      }
    },
    onClear() {
      this.params = {
        installerName: "",
        content: ""
      };
      this.recordListFiltered = this.recordList;
    },
    goback() {
      //返回上一页
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = false;
      this.getPageData();
    },
    getPageData() {
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/h5/listModuleDetail",
        method: "get",
        params: {
          id: this.$route.query.id,
          module: "commissionRecordList",
        },
      }).then((res) => {
        this.recordList = res.data.data.commissionRecordList || [];
        this.recordListFiltered = this.recordList;
        
        this.totalCommissionAmount = this.recordList.reduce((acc, item) => {
          if (item.commissionAmount !== undefined && item.commissionAmount !== null) {
            return acc.plus(new Big(item.commissionAmount || 0));
          }
          return acc;
        }, new Big(0));
        
        this.loading = false;
        this.finished = true;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .van-grid-item__text {
  font-size: 16px;
}

::v-deep .vant-grid-item_content .van-grid-item__content {
  padding-block: 0px;
}
</style>

